import { IProductDataV3, Product } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { NgInject } from '@df/ng/ng-inject';

export interface IHistoryOrderItemData {
    id: number;
    product_id: number;
    name: string;
    sku: string;
    order_id: number;
    qty_ordered: number;
    qty_canceled: number;
    qty_invoiced: number;
    qty_refunded: number;
    qty_shipped: number;
    price: number;
    org_price?: number;
    rowPrice: number;
    row_total_incl_tax: number;
    tax_amount: number;
    tax_percent: number;
    discount_amount: number;
    options?: IHistoryOrderItemDataOption[];
    children?: IHistoryOrderItemData[];
}

export interface IHistoryOrderItemDataOption {
    label?: string;
    value?: number;
    option_id?: number;
    option_value?: number;
}

export interface IHistoryOrderItemConfigurableOption {
    code: string;
    value: any;
}

export class HistoryOrderItem {
    @NgInject(App)
    private app!: App;

    protected _cache: any = {};

    constructor(public data: IHistoryOrderItemData) {}

    get id() {
        return this.data.id;
    }

    get product(): Product<IProductDataV3> | undefined {
        return <Product<IProductDataV3> | undefined>this.app.resources.product.getExisting(this.data.product_id);
    }

    get configurableOptions(): IHistoryOrderItemConfigurableOption[] | undefined {
        const _cache = this._cache;

        if (_cache.configurableOptions === undefined) {
            const product = this.product;
            if (product && product.data) {
                const codes = product.configurableAttributeCodes;
                if (codes) {
                    _cache.configurableOptions = <IHistoryOrderItemConfigurableOption[]>codes
                        .map((code: string) => {
                            if (product.data && product.data[code]) {
                                return <IHistoryOrderItemConfigurableOption>{
                                    code,
                                    value: product.data[code]
                                };
                            }
                            return undefined;
                        })
                        .filter(i => !!i);
                }
            }
        }
        return _cache.configurableOptions;
    }
}

export const historyOrderItemFactory = {
    instance: HistoryOrderItem
};
